module.exports = __webpack_public_path__ + "img/section3_8.c4ab6899.png";